import _ from 'lodash';
import { queryChangePassword, queryChangeTwoFactor, queryGetStProfileInfo } from './services';

const initialState = {
  isCallAction: false,
  actionOption: '',
  userImage: '',
  message: '',
  twoFactorEnabled: null,
};

const Model = {
  namespace: 'profileUser',
  state: initialState,
  effects: {
    *openFormActions({ payload }, { put }) {
      if (payload.mode === 'inline') {
        yield put({
          type: 'userContext/toggleSearchContext',
          payload: false,
        });
      }

      yield put({
        type: 'addActionOption',
        payload: payload.typeAction,
      });
    },

    *changePassword({ payload }, { call, put }) {
      try {
        const response = yield call(queryChangePassword, payload);
        console.log('RESPUESTA DE CAMBIAR PASS: ', response);

        yield put({
          type: 'passwordChanged',
          payload: { message: 'Ud. ha cambiado su contraseña.' },
        });
      } catch (error) {
        console.log('ERROR DE PASS: ', error);
        console.log('ERROR DE PASS: ', error.message);
        yield put({
          type: 'global/showNotificationsform',
          payload: {
            visible: true,
            type: 'error',
            message: error.message,
          },
          validationErrors: error.validationErrors,
        });
      }
    },

    *getProfileInfo({ payload }, { call, put }) {
      try {
        const res = yield call(queryGetStProfileInfo);
        yield put({ type: 'setProfileInfo', payload: res });
      } catch (e) {}
    },

    *changeTwoFactor({ payload }, { call, put }) {
      try {
        yield call(queryChangeTwoFactor, payload.isActive);

        yield put({
          type: 'twoFactorChanged',
          payload: {
            message: `TwoFactor ha sido ${payload.isActive ? 'habilitado' : 'desabilitado'}`,
            status: payload.isActive,
          },
        });
      } catch (error) {
        yield put({
          type: 'global/showNotificationsform',
          payload: {
            visible: true,
            type: 'error',
            message: error.message,
          },
          validationErrors: error.validationErrors,
        });
      }
    },
  },
  reducers: {
    setProfileInfo(state, { payload }) {
      return {
        ...state,
        userImage: payload?.userImage ? payload.userImage : '',
        twoFactorEnabled: payload?.twoFactorEnabled ? payload.twoFactorEnabled : false,
      };
    },

    addActionOption(state, { payload }) {
      return {
        ...state,
        actionOption: payload,
        isCallAction: true,
      };
    },

    twoFactorChanged(state, { payload }) {
      return {
        ...state,
        twoFactorEnabled: payload.status,
        isCallAction: false,
        message: payload.message,
        actionOption: '',
      };
    },

    passwordChanged(state, { payload }) {
      return {
        ...state,
        isCallAction: false,
        actionOption: '',
        message: payload.message,
      };
    },

    toggleAction(state, { payload }) {
      return {
        ...state,
        isCallAction: payload,
      };
    },

    clearMessage(state) {
      return {
        ...state,
        message: '',
      };
    },

    clearState() {
      return {
        message: '',
        isCallAction: false,
        actionOption: '',
        twoFactorEnabled: null,
      };
    },
  },
};

export default Model;
